export const THEME_SUPPORT: {
  [theme: string]: {
    key: string;
    name: string;
    support: {
      aloha: boolean;
      brannan: boolean;
    };
  };
} = {
  antique_lily: {
    key: 'antique_lily',
    name: 'Antique Lily',
    support: {
      aloha: true,
      brannan: false
    }
  },
  blank: {
    key: 'blank',
    name: 'Blank',
    support: {
      aloha: true,
      brannan: true
    }
  },
  blush_muted_floral: {
    key: 'blush_muted_floral',
    name: 'Blush Muted Floral',
    support: {
      aloha: true,
      brannan: true
    }
  },
  bohemian_floral: {
    key: 'bohemian_floral',
    name: 'Bohemian Floral',
    support: {
      aloha: true,
      brannan: true
    }
  },
  branching_out: {
    key: 'branching_out',
    name: 'Branching Out',
    support: {
      aloha: true,
      brannan: true
    }
  },
  bridechilla_confetti: {
    key: 'bridechilla_confetti',
    name: 'Bridechilla Confetti',
    support: {
      aloha: true,
      brannan: false
    }
  },
  bridechilla_rainbows: {
    key: 'bridechilla_rainbows',
    name: 'Bridechilla Rainbows',
    support: {
      aloha: true,
      brannan: false
    }
  },
  bridechilla_triangles: {
    key: 'bridechilla_triangles',
    name: 'Bridechilla Angles',
    support: {
      aloha: true,
      brannan: false
    }
  },
  bright_botanical: {
    key: 'bright_botanical',
    name: 'Bright Botanical',
    support: {
      aloha: true,
      brannan: false
    }
  },
  bronze_floral_frame: {
    key: 'bronze_floral_frame',
    name: 'Bronze Floral Frame',
    support: {
      aloha: true,
      brannan: true
    }
  },
  bronzed_leaves: {
    key: 'bronzed_leaves',
    name: 'Bronzed Leaves',
    support: {
      aloha: true,
      brannan: true
    }
  },
  bubble_gum: {
    key: 'bubble_gum',
    name: 'Bubblegum',
    support: {
      aloha: true,
      brannan: false
    }
  },
  calligraphic_botanical: {
    key: 'calligraphic_botanical',
    name: 'Calligraphic Botanical',
    support: {
      aloha: true,
      brannan: true
    }
  },
  captain_warren_abdul: {
    key: 'captain_warren_abdul',
    name: 'Captain Warren Abdul',
    support: {
      aloha: true,
      brannan: false
    }
  },
  cascading_altar: {
    key: 'cascading_altar',
    name: 'Cascading Altar',
    support: {
      aloha: true,
      brannan: true
    }
  },
  chandelier: {
    key: 'chandelier',
    name: 'Chandelier',
    support: {
      aloha: true,
      brannan: false
    }
  },
  classic_linen: {
    key: 'classic_linen',
    name: 'Classic Linen',
    support: {
      aloha: true,
      brannan: true
    }
  },
  classico: {
    key: 'classico',
    name: 'Classico',
    support: {
      aloha: true,
      brannan: false
    }
  },
  cosmic_night: {
    key: 'cosmic_night',
    name: 'Cosmic Night',
    support: {
      aloha: true,
      brannan: true
    }
  },
  cotton_candy: {
    key: 'cotton_candy',
    name: 'Cotton Candy',
    support: {
      aloha: true,
      brannan: true
    }
  },
  crystal_dawn: {
    key: 'crystal_dawn',
    name: 'Crystal Dawn',
    support: {
      aloha: true,
      brannan: true
    }
  },
  crystal_dusk: {
    key: 'crystal_dusk',
    name: 'Crystal Dusk',
    support: {
      aloha: true,
      brannan: true
    }
  },
  dark_thorn: {
    key: 'dark_thorn',
    name: 'Dark Thorn',
    support: {
      aloha: true,
      brannan: true
    }
  },
  dream_wash: {
    key: 'dream_wash',
    name: 'Dream Wash',
    support: {
      aloha: true,
      brannan: true
    }
  },
  earthly_organic: {
    key: 'earthly_organic',
    name: 'Earthly Organic',
    support: {
      aloha: true,
      brannan: true
    }
  },
  edgy_curtain: {
    key: 'edgy_curtain',
    name: 'Edgy Curtain',
    support: {
      aloha: true,
      brannan: false
    }
  },
  elegance: {
    key: 'elegance',
    name: 'Elegance',
    support: {
      aloha: true,
      brannan: true
    }
  },
  elegant_eucalyptus: {
    key: 'elegant_eucalyptus',
    name: 'Elegant Eucalyptus',
    support: {
      aloha: true,
      brannan: true
    }
  },
  elegant_industrial: {
    key: 'elegant_industrial',
    name: 'Elegant Industrial',
    support: {
      aloha: true,
      brannan: true
    }
  },
  elegant_oasis: {
    key: 'elegant_oasis',
    name: 'Elegant Oasis',
    support: {
      aloha: true,
      brannan: true
    }
  },
  elegant_paper: {
    key: 'elegant_paper',
    name: 'Elegant Paper',
    support: {
      aloha: true,
      brannan: true
    }
  },
  elegant_paradise: {
    key: 'elegant_paradise',
    name: 'Elegant Paradise',
    support: {
      aloha: true,
      brannan: false
    }
  },
  endless_time: {
    key: 'endless_time',
    name: 'Endless Time',
    support: {
      aloha: true,
      brannan: false
    }
  },
  falling_leaves: {
    key: 'falling_leaves',
    name: 'Falling Leaves',
    support: {
      aloha: true,
      brannan: false
    }
  },
  fancy_curtain: {
    key: 'fancy_curtain',
    name: 'Fancy Curtain',
    support: {
      aloha: true,
      brannan: false
    }
  },
  fern_botanical: {
    key: 'fern_botanical',
    name: 'Fern Botanical',
    support: {
      aloha: true,
      brannan: true
    }
  },
  fionas_flowers: {
    key: 'fionas_flowers',
    name: `Fiona's Flowers`,
    support: {
      aloha: true,
      brannan: false
    }
  },
  first_jasmine: {
    key: 'first_jasmine',
    name: 'First Jasmine',
    support: {
      aloha: true,
      brannan: false
    }
  },
  floral_bouquet: {
    key: 'floral_bouquet',
    name: 'Floral Bouquet',
    support: {
      aloha: true,
      brannan: true
    }
  },
  floral_lace: {
    key: 'floral_lace',
    name: 'Floral Lace',
    support: {
      aloha: true,
      brannan: false
    }
  },
  formal_ampersand: {
    key: 'formal_ampersand',
    name: 'Formal Ampersand',
    support: {
      aloha: true,
      brannan: false
    }
  },
  gold_vines: {
    key: 'gold_vines',
    name: 'Gold Vines',
    support: {
      aloha: true,
      brannan: true
    }
  },
  golden_haze: {
    key: 'golden_haze',
    name: 'Golden Haze',
    support: {
      aloha: true,
      brannan: true
    }
  },
  graphite: {
    key: 'graphite',
    name: 'Graphite',
    support: {
      aloha: true,
      brannan: true
    }
  },
  illustrated_book: {
    key: 'illustrated_book',
    name: 'Illustrated Book',
    support: {
      aloha: true,
      brannan: true
    }
  },
  lavendar_yard: {
    key: 'lavendar_yard',
    name: 'Lavender Yard',
    support: {
      aloha: true,
      brannan: false
    }
  },
  lavender_sage: {
    key: 'lavender_sage',
    name: 'Lavender Sage',
    support: {
      aloha: true,
      brannan: false
    }
  },
  lemons_and_flowers: {
    key: 'lemons_and_flowers',
    name: 'Lemons and Flowers',
    support: {
      aloha: true,
      brannan: false
    }
  },
  light_snow: {
    key: 'light_snow',
    name: 'Light Snow',
    support: {
      aloha: true,
      brannan: false
    }
  },
  lovebirds: {
    key: 'lovebirds',
    name: 'Lovebirds',
    support: {
      aloha: true,
      brannan: false
    }
  },
  lush_greenery: {
    key: 'lush_greenery',
    name: 'Lush Greenery',
    support: {
      aloha: true,
      brannan: true
    }
  },
  metallic_wreath: {
    key: 'metallic_wreath',
    name: 'Metallic Wreath',
    support: {
      aloha: true,
      brannan: true
    }
  },
  midnight: {
    key: 'midnight',
    name: 'Midnight',
    support: {
      aloha: true,
      brannan: false
    }
  },
  midnight_peony: {
    key: 'midnight_peony',
    name: 'Midnight Peony',
    support: {
      aloha: true,
      brannan: true
    }
  },
  mod_marble: {
    key: 'mod_marble',
    name: 'Mod Marble',
    support: {
      aloha: true,
      brannan: true
    }
  },
  modern_bohemian: {
    key: 'modern_bohemian',
    name: 'Modern Bohemian',
    support: {
      aloha: true,
      brannan: false
    }
  },
  modern_branches: {
    key: 'modern_branches',
    name: 'Modern Branches',
    support: {
      aloha: true,
      brannan: false
    }
  },
  modern_brushstrokes: {
    key: 'modern_brushstrokes',
    name: 'Modern Brushstrokes',
    support: {
      aloha: true,
      brannan: true
    }
  },
  modern_marble: {
    key: 'modern_marble',
    name: 'Modern Marble',
    support: {
      aloha: true,
      brannan: true
    }
  },
  mount_baker: {
    key: 'mount_baker',
    name: 'Mount Baker',
    support: {
      aloha: true,
      brannan: false
    }
  },
  muted_floral: {
    key: 'muted_floral',
    name: 'Muted Floral',
    support: {
      aloha: true,
      brannan: true
    }
  },
  natural_laurel: {
    key: 'natural_laurel',
    name: 'Natural Laurel',
    support: {
      aloha: true,
      brannan: true
    }
  },
  new_york_lights: {
    key: 'new_york_lights',
    name: 'New York Lights',
    support: {
      aloha: true,
      brannan: false
    }
  },
  northwest: {
    key: 'northwest',
    name: 'The Northwest',
    support: {
      aloha: true,
      brannan: true
    }
  },
  painted_pink: {
    key: 'painted_pink',
    name: 'Painted Pink',
    support: {
      aloha: true,
      brannan: true
    }
  },
  painterly_blooms_one: {
    key: 'painterly_blooms_one',
    name: 'Painterly Blooms One',
    support: {
      aloha: true,
      brannan: false
    }
  },
  painterly_blooms_two: {
    key: 'painterly_blooms_two',
    name: 'Painterly Blooms Two',
    support: {
      aloha: true,
      brannan: false
    }
  },
  painterly_bohemian: {
    key: 'painterly_bohemian',
    name: 'Painterly Bohemian',
    support: {
      aloha: true,
      brannan: true
    }
  },
  painterly_gem: {
    key: 'painterly_gem',
    name: 'Painterly Gem',
    support: {
      aloha: true,
      brannan: true
    }
  },
  palace: {
    key: 'palace',
    name: 'Palace',
    support: {
      aloha: true,
      brannan: true
    }
  },
  papel_picado: {
    key: 'papel_picado',
    name: 'Papel Picado',
    support: {
      aloha: true,
      brannan: false
    }
  },
  porcelain_breeze: {
    key: 'porcelain_breeze',
    name: 'Porcelain Breeze',
    support: {
      aloha: true,
      brannan: true
    }
  },
  queens_palace: {
    key: 'queens_palace',
    name: 'Queens Palace',
    support: {
      aloha: true,
      brannan: false
    }
  },
  raspberry_sherbet: {
    key: 'raspberry_sherbet',
    name: 'Raspberry Sherbet',
    support: {
      aloha: true,
      brannan: false
    }
  },
  romantic_garland: {
    key: 'romantic_garland',
    name: 'Romantic Garland',
    support: {
      aloha: true,
      brannan: true
    }
  },
  romantic_succulents: {
    key: 'romantic_succulents',
    name: 'Romantic Succulents',
    support: {
      aloha: true,
      brannan: true
    }
  },
  rose_sunset: {
    key: 'rose_sunset',
    name: 'Rose Sunset',
    support: {
      aloha: true,
      brannan: false
    }
  },
  rustic_elegance: {
    key: 'rustic_elegance',
    name: 'Rustic Elegance',
    support: {
      aloha: true,
      brannan: true
    }
  },
  rustic_wreath: {
    key: 'rustic_wreath',
    name: 'Rustic Wreath',
    support: {
      aloha: true,
      brannan: true
    }
  },
  san_francisco: {
    key: 'san_francisco',
    name: 'San Francisco',
    support: {
      aloha: true,
      brannan: false
    }
  },
  sea_salt: {
    key: 'sea_salt',
    name: 'Sea Salt',
    support: {
      aloha: true,
      brannan: true
    }
  },
  silver_haze: {
    key: 'silver_haze',
    name: 'Silver Haze',
    support: {
      aloha: true,
      brannan: true
    }
  },
  simple_rustic: {
    key: 'simple_rustic',
    name: 'Simple Rustic',
    support: {
      aloha: true,
      brannan: true
    }
  },
  spring_flowers: {
    key: 'spring_flowers',
    name: 'Spring Flowers',
    support: {
      aloha: true,
      brannan: false
    }
  },
  spring_pink: {
    key: 'spring_pink',
    name: 'Spring Pink',
    support: {
      aloha: true,
      brannan: false
    }
  },
  star_gazing: {
    key: 'star_gazing',
    name: 'Star Gazing',
    support: {
      aloha: true,
      brannan: true
    }
  },
  strung_in_love: {
    key: 'strung_in_love',
    name: 'Strung In Love',
    support: {
      aloha: true,
      brannan: true
    }
  },
  strung_lights: {
    key: 'strung_lights',
    name: 'Strung Lights',
    support: {
      aloha: true,
      brannan: true
    }
  },
  summer_linen: {
    key: 'summer_linen',
    name: 'Summer Linen',
    support: {
      aloha: true,
      brannan: false
    }
  },
  toran: {
    key: 'toran',
    name: 'Toran',
    support: {
      aloha: true,
      brannan: false
    }
  },
  victorian: {
    key: 'victorian',
    name: 'Victorian',
    support: {
      aloha: true,
      brannan: true
    }
  },
  vintage_flowers: {
    key: 'vintage_flowers',
    name: 'Vintage Flowers',
    support: {
      aloha: true,
      brannan: false
    }
  },
  vintage_mountain: {
    key: 'vintage_mountain',
    name: 'Vintage Mountain',
    support: {
      aloha: true,
      brannan: true
    }
  },
  vintage_sunset: {
    key: 'vintage_sunset',
    name: 'Vintage Sunset',
    support: {
      aloha: true,
      brannan: false
    }
  },
  watercolor_beach: {
    key: 'watercolor_beach',
    name: 'Watercolor Beach',
    support: {
      aloha: true,
      brannan: true
    }
  },
  watercolor_beach_two: {
    key: 'watercolor_beach_two',
    name: 'Watercolor Beach 2',
    support: {
      aloha: true,
      brannan: false
    }
  },
  watercolor_cactus: {
    key: 'watercolor_cactus',
    name: 'Watercolor Cactus',
    support: {
      aloha: true,
      brannan: true
    }
  },
  we_do: {
    key: 'we_do',
    name: 'We Do',
    support: {
      aloha: true,
      brannan: false
    }
  },
  wonderferris: {
    key: 'wonderferris',
    name: 'Wonderferris',
    support: {
      aloha: true,
      brannan: true
    }
  },
  woodgrain_lace: {
    key: 'woodgrain_lace',
    name: 'Woodgrain Lace',
    support: {
      aloha: true,
      brannan: true
    }
  },
  woodgrain_lace_wood: {
    key: 'woodgrain_lace_wood',
    name: 'Woodgrain Lace 2',
    support: {
      aloha: true,
      brannan: false
    }
  },
  woodsy_wreath: {
    key: 'woodsy_wreath',
    name: 'Woodsy Wreath',
    support: {
      aloha: true,
      brannan: false
    }
  },
  wreath: {
    key: 'wreath',
    name: 'Alpine Wreath',
    support: {
      aloha: true,
      brannan: true
    }
  },
  zen_flower: {
    key: 'zen_flower',
    name: 'Zen Flower',
    support: {
      aloha: true,
      brannan: false
    }
  }
};
